//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  provide() {
    return {
      container: this,
    }
  },

  props: {
    hasBorder: {
      type: Boolean,
      default: true,
      required: false,
    },

    gray: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  computed: {
    hasTag() {
      return !!this.$slots.tag?.[0]?.text
    },
  },
}
